import { createApi } from '@reduxjs/toolkit/query/react';
import { createSentryFetchBaseQuery } from '../../app/api/sentryFetchBaseQuery';
import { CreateDivisionInput, DivisionResponse, GetDivisionsResponse } from './divisions.types';
import { getClientCredentials } from '../../app/shared/utils/cookie.utils';

export const divisionsApi = createApi({
  reducerPath: 'divisionsApi',
  baseQuery: createSentryFetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/project/`,
    prepareHeaders: headers => {
      // Add authorization token
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      // Add client credentials based on selected environment
      const environment = (localStorage.getItem('SELECTED_ENV') || 'DEV') as 'DEV' | 'PROD';
      const credentials = getClientCredentials(environment);
      const userId = localStorage.getItem('userId');
      if (credentials) {
        headers.set('X-Client-Id', credentials.clientId);
        if (credentials.clientSecret) {
          headers.set('X-Client-Secret', credentials.clientSecret);
        }
      }
      if (userId) {
        headers.set('X-User-Id', userId);
      }

      return headers;
    }
  }),
  endpoints: builder => ({
    // Get All Divisions
    getDivisions: builder.query<GetDivisionsResponse, string>({
      query: organizationId => `divisions?organizationId=${organizationId}`
    }),

    // Create Division
    createDivision: builder.mutation<DivisionResponse, CreateDivisionInput>({
      query: body => ({
        url: 'create-division',
        method: 'POST',
        body
      })
    })
  })
});

export const { useGetDivisionsQuery, useCreateDivisionMutation } = divisionsApi;
